// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ihxwvmunmcxpwjnjlduv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImloeHd2bXVubWN4cHdqbmpsZHV2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg3MTQ2NjEsImV4cCI6MjA1NDI5MDY2MX0._wb-7ts7Y0VJdj_t0VwhquJYFigvcISKww8zDNKOsxs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);